<template>
    <div class="section-title-parent">
        <div class="section-anchor"></div>
        <div class="section-title">
            {{ title }}
        </div>
    </div>

</template>
  
<script>
export default {
    name: 'SectionTitle',
    props: ['title']
}
</script>
  
<style scoped>
.section-title-parent {
    display: flex;
    align-items: center;
}

.section-anchor {
    background-color: rgb(51, 164, 240);
    width: 4px;
    height: 15px;
    border-radius: 2px;
    margin-right: 10px;
}

.section-title {
    color: black;
    font-weight: normal;
    font-size: medium;
}
</style>
  